export function extractProjectAccessLabels(projects) {
  const labels = new Set();

  (projects || []).forEach((project) => {
    (project?.accessCatalog || []).forEach((entry) => {
      const label = typeof entry?.label === "string" ? entry.label.trim() : "";
      if (label) {
        labels.add(label);
      }
    });
  });

  return Array.from(labels).sort((left, right) => left.localeCompare(right));
}
